import ArrowIcon from '../../../../../../ui/svg/common/arrow';
import React from 'react';
import { ICartItem } from '../../../interfaces';
import { rootActions, useAppDispatch } from '../../../data/store';
import { updateQuantity } from '../../../data/data-service';
import { getLocalData } from '../../../domain/shopping-cart-address-provider';
import { undoCartItem } from '../../../domain/undo-cart-item-provider';
import { sendGAEvent } from '../../../../../../domain/marketing/gtm-provider';

interface IQuantity {
    cartItem: ICartItem,
    classes?: string,
}

/**
 * Update qty widget
 */
const Quantity = (props: IQuantity) => {

    const dispatch = useAppDispatch();
    /**
     * update qty
     */
    const updateQuantityHandler = async (evt: React.MouseEvent, shouldIncrease: boolean) => {

        // prevent multiple clicks
        if(evt.detail && evt.detail !== 1) return;

        const newQty = shouldIncrease ? props.cartItem.skuUnits + 1 : props.cartItem.skuUnits - 1;
        if(newQty < 0) return;

        const response = await updateQuantity(
            props.cartItem.cartItemGUID,
            newQty,
            getLocalData()
        );

        if(!response || response.statusCode !== 200 || !response.data.isValid || !response.data.relatedData) return;

        dispatch(
            rootActions.setCartData(response.data.relatedData)
        );

        if(newQty === 0){
            // handle 'undo cart items'
            dispatch(
                rootActions.main({
                    removedItems: undoCartItem(props.cartItem) || [],
                })
            );
        }

        sendGAEvent('Cart Quantity', shouldIncrease ? 'Increase' : 'Decrease');
    };

    return (
        <div className={ props.classes ? props.classes : 'flex items-start justify-center text-center mx-6' }>

            {
                !props.cartItem.isQtyControl &&
                <div>{ props.cartItem.skuUnits }</div>
            }

            {
                props.cartItem.isQtyControl &&
                <div className="flex items-center border rounded px-4 py-2">
                    <div className="mr-4 font-bold" data-qa="cart-step1-qty-value">{ props.cartItem.skuUnits }</div>

                    <div className="flex flex-col">

                        <button type="button" className="p-1" onClick={ async evt => {
                            await updateQuantityHandler(evt, true);
                        }}>
                            <ArrowIcon
                                width="10px"
                                color="#4a4a4a"
                                title={`Increase quantity of ${ props.cartItem.skuName }`}
                                rotationAngle={ 180 }
                            />
                        </button>

                        <button
                            type="button"
                                className="p-1"
                                onClick={ async evt => {
                            await updateQuantityHandler(evt, false);
                        }}>
                            <ArrowIcon
                                width="10px"
                                color="#4a4a4a"
                                title={`Decrease quantity of ${ props.cartItem.skuName }`}
                                rotationAngle={ 0 }
                            />
                        </button>

                    </div>

                </div>
            }
        </div>
    )
};

export default Quantity;